import { ThreadProviders, ThemeModes } from '@primerai/thread';
import config from '~/config';

const mode = ThemeModes.LIGHT;

const ThreadThemeProvider = ({ children }: React.PropsWithChildren) => (
  <ThreadProviders fontBaseUrl={config.VITE_PRIMER_CDN_URL} mode={mode}>
    {children}
  </ThreadProviders>
);

export default ThreadThemeProvider;
